import React, { useRef } from "react";
import { Row, Button as AntdButton, Form, Input, Col, message, Table } from "antd";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import { UploadOutlined } from '@ant-design/icons';
import { UploadUserTag } from './UserCardCmnts'
import Heading from '../../../../components/heading/heading';
import { MultiFileUpload } from '../../../../Api/Services/CommonApiService'

function convertAndFormatDateTime2(dateTime, company, profile) {
    if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
    const extractTimezoneName = (tzStr) => {
        const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
        return match ? match[1] : "";
    };
    const fromTimezone = extractTimezoneName(company?.timeZone);
    const toTimezone = extractTimezoneName(profile?.timeZone);
    if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
        console.warn("Invalid timezone provided");
        return "";
    }
    const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
    const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
    const formattedDate = converted.format(dateFormat);

    return formattedDate
}
const RelatedDocUpload = ({ edit, FILEList, setFileList, form }) => {
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const MAX_FILE_SIZE = Number(process.env.REACT_APP_MAX_FILE_SIZE) // 20 MB
    const fileInputRef = useRef(null);
    const removeFile = async (index) => {
        const updatedFormData = [...FILEList];
        updatedFormData.splice(index, 1);
        setFileList(updatedFormData);

        // Remove stale field from form
        const fieldName = `title-${index}`;
        form.setFieldsValue({ [fieldName]: undefined });

        // Optional: clean up all dynamic fields if needed
        const newFields = {};
        updatedFormData.forEach((file, i) => {
            newFields[`title-${i}`] = file.title;
        });
        form.setFieldsValue(newFields);
    };
    const handleFileListChange = async (index, fieldName, value) => {
        const updatedFormData = [...FILEList];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };
        setFileList(updatedFormData);
    };
    const FilesColumns = [
        // {
        //     title: 'Title',
        //     dataIndex: 'title',
        //     key: 'title',
        //     render: (text, record, index) => (
        //         <Form.Item name={`title-${index}`} initialValue={record.title} rules={[{ required: true, message: 'Title is required' }]} >
        //             {edit ? <Input
        //                 name="title"
        //                 value={record.title}
        //                 onChange={(e) =>
        //                     handleFileListChange(index, 'title', e.target.value)
        //                 }
        //                 placeholder="Enter Title" />
        //                 : <span >
        //                     {record.title}
        //                 </span>}
        //         </Form.Item>
        //     ),
        //     width: '25%',
        // },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            render: (text, record, index) => (
                <Form.Item
                    name={`title-${index}`}
                    initialValue={record.title}
                    rules={[{
                        required: true,
                        whitespace: true, message: 'Title is required'
                    }]}
                >
                    {edit ? (
                        <Input
                            value={record.title}
                            onChange={(e) =>
                                handleFileListChange(index, 'title', e.target.value)
                            }
                            placeholder="Enter Title"
                        />
                    ) : (
                        <span>{record.title}</span>
                    )}
                </Form.Item>
            ),
            width: '25%',
        },
        {
            title: "File Name",
            dataIndex: 'fileName',
            key: 'fileName',
            render: (text, record) => (
                <Form.Item>
                    <span>
                        {record.fileName}
                    </span>
                </Form.Item>
            ),
            width: '20%',
        },
        {
            title: "Type",
            dataIndex: 'type',
            key: 'type',
            width: '10%',
            render: (text, record) => (
                <Form.Item><span >{record.type}</span></Form.Item>
            ),
        },
        {
            title: "Uploaded By",
            dataIndex: 'uploadedBy',
            key: 'uploadedBy',
            width: '25%',
            render: (text, record) => (
                <Form.Item>
                    <UploadUserTag record={record} />
                </Form.Item>
            ),
        },
        {
            title: "Uploaded Date",
            dataIndex: 'uploadedDate',
            key: 'uploadedDate',
            width: '15%',
            render: (text, record) => (
                <Form.Item><span> {convertAndFormatDateTime2(record?.uploadedDate, companyProfile, profile)}</span></Form.Item>
            )
        },
        {
            title: '',
            dataIndex: 'download',
            key: 'download',
            width: '10%',
            render: (text, record) => (
                <Form.Item>
                    <a href={record.url} download={record.fileName}> <FeatherIcon icon="download-cloud" size={25} /> </a>
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '5%',
            render: (text, record, index) => {
                if (edit && FILEList.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            onClick={() => removeFile(index)}
                        />
                    );
                }
            },
        },
    ];
    function getCurrentDateTimeFromZoneString(tzStr) {
        if (!tzStr) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const timezone = extractTimezoneName(tzStr)
        if (!moment.tz.zone(timezone)) {
            console.warn("Invalid timezone:", timezone);
            return "";
        }
        return moment.tz(timezone).format("YYYY-MM-DD HH:mm");
    }
    const handlefileuploadChange = async (e) => {
        let hideMessage;
        const files = Array.from(e.target.files);
        const formData = new FormData();
        files.forEach(file => {
            formData.append('files', file);
        });
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await MultiFileUpload(formData);
            if (response.status === 201) {
                const updatedFileList = response.data.map((fileItem) => {
                    const formattedDateTime = getCurrentDateTimeFromZoneString(companyProfile?.timeZone);
                    const Filename = fileItem.mediaName.replace(/^files-\d+\./, '');
                    const lastDotIndex = fileItem.mediaName.lastIndexOf('.');
                    const extensionWithDot = fileItem.mediaName.slice(lastDotIndex + 1);
                    return {
                        title: undefined,
                        fileName: Filename,
                        type: extensionWithDot,
                        uploadedById: profile.userId,
                        uploadedBy: `${profile.firstName} ${profile.lastName}`,
                        uploadedProfile: profile.profilePic,
                        uploadedDate: formattedDateTime,
                        url: fileItem.mediaUrl,
                    };
                });
                hideMessage();
                // setFileList(prevFileList => [...prevFileList, ...updatedFileList]);
                setFileList([...FILEList, ...updatedFileList]);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            }
        } catch (error) {
            hideMessage();
            message.error(error);
        }
    };
    return (
        <>
            <div style={{ display: "flex", alignItems: "center", gap: "50px" }}>
                <Heading as="h5">Related Documents</Heading>
                {edit &&
                    <div>
                        <input
                            type="file"
                            name="files"
                            multiple
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={(e) => {
                                const files = Array.from(e.target.files);
                                if (files.length > 5) {
                                    message.warning("You can upload a maximum of 5 files at a time");
                                } else if (files.some(file => file.size > MAX_FILE_SIZE)) {
                                    message.error(`One or more files exceed the maximum size of 5 MB.`);
                                } else {
                                    handlefileuploadChange(e);
                                }
                            }}
                        />
                        <AntdButton icon={<UploadOutlined />} onClick={() => fileInputRef.current.click()}                                                                                        >
                            Click to Upload
                        </AntdButton>
                    </div>
                }
            </div>
            {FILEList.length > 0 ?
                <Row gutter={30} style={{ margin: "20px 0px" }}>
                    <Col span={24} style={{ marginBottom: 20 }}>
                        <div className={`table-bordered leaderboard-table table-responsive ${edit && 'FileTable'}`}>
                            <Table
                                dataSource={FILEList}
                                columns={FilesColumns}
                                rowKey={(record, index) => index.toString()}
                                pagination={false}
                            />
                        </div>
                    </Col>
                </Row> : <Row gutter={30} style={{ margin: "20px 0px" }} />
            }
        </>
    )
}
RelatedDocUpload.propTypes = {
    FILEList: PropTypes.array.isRequired,
    setFileList: PropTypes.func.isRequired,
    edit: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
};
const RelatedDocs = ({ file, index }) => {
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const shortenFilename = (filename, maxLength = 20) => {
        const extension = filename.substring(filename.lastIndexOf('.'));
        const nameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'));
        if (nameWithoutExtension.length > maxLength) {
            return `${nameWithoutExtension.substring(0, maxLength)}...${extension}`;
        }
        return filename;
    };
    return (<div className='RightSide-Pic-DataShadow' key={index}>
        <div style={{ padding: "10px", }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                <div className='doc-title div-ellipsis'>{file?.title}</div>
            </div>
            <div className='doc-date' style={{ fontSize: "12px", marginBottom: 5 }}>Uploaded by</div>
            <div style={{ display: "flex", alignItems: "center", fontSize: "14px", minWidth: 0, overflow: "hidden" }}>
                <div style={{ flex: "1 1 0", minWidth: 0, overflow: "hidden" }}>
                    <UploadUserTag record={file} page="ReDoc" />
                </div>
                <div style={{ flexShrink: 0, whiteSpace: "nowrap", marginLeft: 5 }}>on</div>
                <div style={{ flexShrink: 0, whiteSpace: "nowrap", marginLeft: 5, color: "black" }}>
                    {convertAndFormatDateTime2(file?.uploadedDate, companyProfile, profile)}
                </div>
            </div>
        </div>
        <div style={{ padding: "10px", borderTop: "1px solid #ddd", display: "flex", alignItems: "center", justifyContent: "space-between" }} >
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <div>
                    <img style={{ height: "25px" }}
                        src={require('../../../../static/img/defaultImages/justify.png')}
                        alt={file.fileName}
                    />
                </div>
                <div>
                    <div title={file.filename} style={{
                        cursor: "default",
                        fontWeight: 700,
                        fontSize: 12,
                    }}>{shortenFilename(file.fileName, 20)}</div>
                </div>
            </div>
            <div>
                <a href={file.url} download={file.fileName}> <FeatherIcon icon="download-cloud" size={20} style={{ display: "flex", alignItems: "center" }} /> </a>
            </div>
        </div>
    </div>)
}
RelatedDocs.propTypes = {
    file: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
};

export { RelatedDocUpload, RelatedDocs }